// COPIED from ptc-core web/src/shell/FeedbackMenu.tsx @ de39fff (fleet feedback widget contract
// v1, 2026-10-21), ported to this app's own Popover idiom rather than its source's hand-rolled
// div popover. Core hand-rolled its popover because "Fluent popup surfaces are hostile to jsdom
// tests" -- that is not true here: NotificationBell.tsx (the sibling header icon right next to
// this one) already uses Fluent's Popover/PopoverSurface with a passing test suite
// (NotificationBell.test.tsx), so there is no reason to depart from this app's own idiom.
// Conformance: FeedbackWidgetConformance.test.tsx.
//
// Mounted in AppHeader.tsx, beside NotificationBell and the user menu -- staff-only by
// construction, since AppHeader only renders inside AppLayout, which the client-facing /portal
// route (App.tsx) never reaches.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  Tooltip,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { PersonFeedbackRegular } from '@fluentui/react-icons';
import type { FeedbackKind } from '../../services/feedbackApi';
import { FeedbackDialog } from './FeedbackDialog';

const useStyles = makeStyles({
  surface: {
    padding: tokens.spacingVerticalXS,
    minWidth: '220px',
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    justifyContent: 'flex-start',
    width: '100%',
  },
});

export default function FeedbackMenu() {
  const { t } = useTranslation();
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState<FeedbackKind | null>(null);

  function choose(k: FeedbackKind) {
    setOpen(false);
    setKind(k);
  }

  return (
    <>
      <Popover open={open} onOpenChange={(_, d) => setOpen(d.open)}>
        <PopoverTrigger disableButtonEnhancement>
          <Tooltip content={t('shell.feedback.menuLabel')} relationship="label">
            <Button
              appearance="transparent"
              aria-label={t('shell.feedback.menuLabel')}
              icon={<PersonFeedbackRegular />}
              style={{ color: 'var(--tl-header-fg)' }}
            />
          </Tooltip>
        </PopoverTrigger>
        <PopoverSurface className={styles.surface}>
          <Button appearance="subtle" className={styles.item} onClick={() => choose('problem')}>
            {t('shell.feedback.problemTitle')}
          </Button>
          <Button appearance="subtle" className={styles.item} onClick={() => choose('improvement')}>
            {t('shell.feedback.improvementTitle')}
          </Button>
        </PopoverSurface>
      </Popover>
      <FeedbackDialog kind={kind} onClose={() => setKind(null)} />
    </>
  );
}
